// extracted by mini-css-extract-plugin
export default {"overlayImagesContainer":"WJ-z","loadingMedia":"XJ-z","reviewsImagesAndVideos":"YJ-z","limitHeight":"ZJ-z"};